/**
 * Extrai saleId e notifyUserId (aliases) de um deeplink de reabertura.
 *
 * Ex.: `/sale/1234?from=notification&action=reopen&requesterUserId=42`
 *
 * @param {string|null|undefined} deeplink
 * @returns {{
 *   pathname: string|null,
 *   saleId: string|null,
 *   from: string|null,
 *   action: string|null,
 *   notifyUserId: number|null,
 *   notificationType: string|null,
 * }}
 */
export function parseSaleReopenNotificationDeeplink(deeplink) {
  const empty = {
    pathname: null,
    saleId: null,
    from: null,
    action: null,
    notifyUserId: null,
    notificationType: null,
  };

  if (typeof deeplink !== "string" || !deeplink.trim()) {
    return empty;
  }

  try {
    const url = new URL(deeplink.trim(), "http://local.invalid");
    const vendasMatch = url.pathname.match(/\/vendas\/([^/?#]+)\/reabrir\/?$/i);
    const saleMatch =
      vendasMatch || url.pathname.match(/\/(?:api\/)?sale\/([^/?#]+)/i);
    const saleId = saleMatch?.[1] ? decodeURIComponent(saleMatch[1]) : null;

    const notifyRaw =
      url.searchParams.get("notifyUserId") ??
      url.searchParams.get("requesterUserId") ??
      url.searchParams.get("requestedByUserId");

    const notifyUserId = parsePositiveInt(notifyRaw);

    return {
      pathname: url.pathname || null,
      saleId,
      from: url.searchParams.get("from"),
      action: url.searchParams.get("action"),
      notifyUserId,
      notificationType:
        url.searchParams.get("notificationType") ??
        url.searchParams.get("type"),
    };
  } catch {
    return empty;
  }
}

/**
 * @param {unknown} value
 * @returns {number|null}
 */
function parsePositiveInt(value) {
  if (value === undefined || value === null || value === "") return null;
  const n = typeof value === "number" ? value : Number(String(value).trim());
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.trunc(n);
}

/**
 * Resolve notifyUserId a partir de query/state/DTO.
 * @param {Object} [input]
 * @returns {number|null}
 */
export function resolveSaleReopenNotifyUserId(input) {
  if (!input || typeof input !== "object") return null;
  return (
    parsePositiveInt(input.notifyUserId) ??
    parsePositiveInt(input.requesterUserId) ??
    parsePositiveInt(input.requestedByUserId)
  );
}
